<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-05 15:14:26
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-09 16:50:35
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\agreement.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="agreement_page">
        <div class="alert-as" ref="agreementComponent" id="agreementComponent">
            <div class="alert-content">
                <div class="ag-all">
                    <div class="ag-all-content">
                        <div style="width: 100%" class="ag-img">
                            <div class="ag-title">
                                <b>特约商户支付服务合作协议</b>
                            </div>
                            <div class="ag-content">
                                <div class="ag-content-content">
                                    <div class="ag-content-content-title" style="text-indent: 2em">
                                        《特约商户支付服务合作协议》（以下简称“本协议”）是拉卡拉支付股份有限公司（正文部分简称“乙方”）与您（是指接受拉卡拉支付服务的个人或公司法人及相关单位组织等，正文部分简称“甲方”）就“支付服务业务”服务（以下简称“本服务”）所订立的有效合约。
                                        您在使用本服务之前，请仔细阅读本协议（特别是以<b>粗体</b>标注的内容），<b>您在拉卡拉客户经理向您展示的本协议上签字，即表示您同意接受本协议的全部内容</b>。如果您不同意本协议的任意内容，或者无法准确理解相关条款，请不要签字。
                                    </div>
                                </div>
                                <div class="ag-content-content">
                                    <div style="text-indent: 2em; line-height: ">甲方：（特约商户）
                                        <span class="feeWrite">{{
                                            businessInformation.merchName
                                        }}</span>
                                    </div>
                                    <div style="text-indent: 2em; line-height: ">乙方：（支付机构）拉卡拉支付股份有限公司</div>
                                </div>
                                <div class="ag-content-content">
                                    <div class="ag-content-content-title"><b>第一条</b> 业务服务及费用：</div>
                                    <div class="ag-content-content-title-span">1．双方确认，乙方向甲方提供支付服务。</div>
                                    <div class="ag-content-content-title-span">
                                        2．甲方使用本服务将会产生相应的收单手续费（详见《拉卡拉商户注册登记表》），甲方也可通过APP查询收单手续费。
                                    </div>
                                    <div class="ag-content-content-title-span">
                                        3．乙方保留调整本协议项下的费用之权利，如本协议项下的费用调整，乙方将以公告方式在拉卡拉网站提示并予以公示，而无需另行通知甲方，调整后的费用标准在公告期届满之日起生效。若甲方在费用标准调整后继续使用本服务的，视为甲方接受费用标准的调整。若甲方不同意调整后的费用标准，应停止使用本服务并与乙方联系。
                                        <div class="ag-content-content">
                                            <div class="ag-content-content-title"><b>第二条</b>
                                                甲方如使用移动通讯受理终端（含内置Esim卡），甲方应向乙方另行支付运营服务费（详见《拉卡拉商户注册登记表》），运营服务包括终端网络维护，质量管理，应急响应等，服务期自终端入网之日起1年。甲方应自本协议生效之日起1个工作日内向乙方支付首年运营服务费，首年服务到期30日前向乙方支付次年运营服务费，以此类推。
                                            </div>
                                            <div class="ag-content-content-title-span"></div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第三条</b>
                                                    乙方应将甲方的交易资金在扣除本协议约定的手续费和其他款项后，在约定的结算周期（详见《拉卡拉商户注册登记表》）内，向甲方指定的结算账户划付资金，境外卡支付业务在3个工作日内划付资金。甲方可根据需求选择开通交易发生日结算，乙方审核通过后，将另行扣收相应的快速结算手续费<sup>1</sup>，具体以拉卡拉商户通APP展示的为准。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第四条</b>
                                                    甲方默认开通退货功能，当甲方发生退货、撤销、冲正交易情形时，乙方有权采用以下一或多种模式将退款资金扣除：（1）从甲方退款终端交易资金中直接扣除；（2）从甲方退款商户交易资金中直接扣除；（3）从甲方退货账户资金中直接扣除；（4）从甲方合作平台/集团商户退货账户资金中直接扣除。如甲方需关闭退货功能，甲方可拨打乙方客服电话95016关闭退货功能。
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    对甲方、合作平台/集团商户退货账户进行扣款后，甲方同意并授权乙方依据实际情况将甲方交易资金回充至相应退货账户。甲方因退货操作错误等原因造成的资金风险及损失由甲方承担。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第五条</b>
                                                    乙方应按国家法律法规履行支付机构相关责任与义务。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第六条</b>
                                                    乙方（含乙方分支机构、合作方,下同）为甲方提供的受理终端（包含收款码）仅限甲方在固定地区使用。
                                                    甲方应提供符合受理终端安装要求的场地条件，并妥善保管和使用，如因甲方管理或使用不当造成终端损坏或遗失的，甲方应按市场价向乙方赔偿，<b>赔付方式为现金、转账或授权乙方从甲方终端押金、交易资金等途径扣除。</b>
                                                    双方协议终止时，乙方有权收回放置在甲方的受理终端或关闭网络支付接口。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第七条</b>
                                                    受理终端收费标准由乙方与甲方另行约定。固定受理终端、移动受理终端、扫码受理终端数量及型号以拉卡拉客户端及拉卡拉商户通APP展示的数量及型号为准。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第八条</b>
                                                    甲方应准确填写附件《拉卡拉商户注册登记表》中的相关信息，当甲方的工商注册名称、主营业务、法定代表人或负责人、结算账户信息等重要信息发生变更时，甲方应通过乙方官方渠道方式告知乙方，乙方有权重新审核甲方支付业务受理资质。
                                                    当乙方认为甲方不再具备受理资质时，乙方有权单方面终止本协议。
                                                    甲方申请成为乙方特约商户，应主动如实提供经营资质材料及身份证明文件。
                                                    甲方应保证上述资料完整、真实、合法、有效。若身份证明文件存在有效期，应在有效期前主动向乙方提供新的证明文件，证明文件失效且经乙方提示仍无合理理由拒绝更新的，乙方有权对甲方采取交易限制措施或终止向甲方提供本协议项下相关的服务。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第九条</b>
                                                    甲方应当履行以下基本义务：
                                                    <div class="ag-content-content-title-span">
                                                        1．基于真实的商品或服务交易背景受理银行卡，并遵守相应银行卡品牌的受理要求，不得歧视和拒绝同一银行卡品牌的不同发卡银行的持卡人；
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        2．按规定使用受理终端（网络支付接口）和收单结算账户，不得利用其从事或协助他人从事非法活动；
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        3．妥善处理交易数据信息、保存交易凭证，保障交易信息安全；
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        4．不得因持卡人使用银行卡而向持卡人收取或变相收取附加费用，或降低服务水平；
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        5．不得存储持卡人银行卡的磁道信息或芯片信息、验证码、有效期、密码等敏感信息；
                                                    </div>
                                                    <div class="ag-content-content-title-span">6．确保网络支付指令的真实性、准确性、合法性；
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        7．仅在中华人民共和国境内（不包含香港特别行政区、澳门特别行政区及台湾地区）使用本支付服务。
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十条 </b>
                                                    对经<b>查实</b>的交易差错或甲方需调整的账务，乙方负责按照中国银联或其他卡组织差错处理的有关规定进行相应处理。对有疑议的交易，乙方有权向甲方调单。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十一条 </b>
                                                    甲方需保存所有交易的签购单及其他的交易证明材料，<b>保存期限自交易日起至少2年</b>，如因甲方资料保存不善造成的风险损失由甲方自行承担。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十二条</b>
                                                    在出现交易纠纷、持卡人调退单或乙方有合理理由认定交易有可疑之处时，乙方有权查验甲方原始交易签购单及相关交易证明材料，并影印留存。
                                                    甲方应根据乙方要求提供真实的交易受理情况，对于乙方提出的调取交易证明材料的要求，甲方应自乙方通知之日（含）起3个工作日内提供有效交易证明材料。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十三条</b>
                                                    <b>甲方发生以下情况时，乙方有权采取暂缓甲方全部或部分交易资金结算至少180天以上：</b>
                                                </div>
                                                <div class="ag-content-content-title-span"><b>1．发卡行发起调、退单；</b></div>
                                                <div class="ag-content-content-title-span">
                                                    <b>2．超出约定地理范围使用终端或终端位置无法监测的；</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>3．交易金额、时间、频率与甲方经营范围、规模不相符等异常情形；</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>4．疑似虚假申请、银行卡套现、洗钱、欺诈、移机、留存或泄漏持卡人账户信息等风险事件；</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>5．从事其他违反国家法律法规规定的犯罪、违法活动；</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>6．乙方认为甲方调退单比例过高、交易纠纷比例过高或有合理理由认定交易存在可疑之处，或有合理根据怀疑甲方违反本协议的其他行为；</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>7．被工商等管理部门吊销营业执照或行政许可等，从而丧失本协议所列经营资格的；</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>8．将乙方支付接口用于非本协议约定业务或提供给本协议约定外的第三人使用。</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>甲方发生以上第2-8项情况时，乙方同时有权设置收款限额、暂停银行卡交易、收回受理终端、关闭网络支付接口、单方面无条件终止本协议等措施，由此带给乙方的相关损失和风险责任由甲方承担。
                                                        且乙方有权将甲方相关信息报送至中国银联或其他卡组织风险信息共享系统及中国支付清算协会风险信息共享系统，并向执法、监管部门、相关征信机构通报，发现甲方涉嫌电信网络新型违法犯罪的，乙方还有权立即向公安机关报告。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十四条
                                                        发生以下情况时，乙方有权从甲方押金、保证金及交易资金中抵扣相应款项，如前述款项不足抵扣的，甲方应根据乙方要求补足差额资金。对因甲方原因造成的乙方垫款或损失，乙方有权向甲方追索。</b>
                                                    <div class="ag-content-content-title-span"><b>1．甲方发生退货、冲正、撤销交易；</b>
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        <b>2．由于计算错误或其它原因导致乙方向甲方多支付的款项或其它经甲方确认的长款；</b>
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        <b>3．因甲方原因导致的发卡机构退单或卡组织追究乙方违约金；</b>
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        <b>4．名义经营范围与实际情况不符而造成的本协议项下的费用差额补偿部分（补偿部分的时限为自发现日起前180天）；</b>
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        <b>5．甲方违反本协议约定，导致乙方先行垫付相关方赔偿还款的；</b>
                                                    </div>
                                                    <div class="ag-content-content-title-span"><b>6．其它应由甲方支付的款项。</b>
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        <b>本条款不随双方协议终止而终止，乙方在法律规定的诉讼时效内，均有权就合作期间甲方因本条款给乙方造成的损失向甲方追索。</b>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十五条</b>
                                                    乙方有权对甲方进行风险评级，如甲方风险等级较高，乙方对其开通的受理卡种和交易类型进行限制，并采取强化交易监测、设置交易限额、延迟结算、增加检查频率、建立特约商户风险准备金等风险管理措施。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十六条</b>
                                                    乙方有权对甲方经营场所进行现场检查，如甲方无固定经营场所，乙方有权要求甲方定期上传经营影像或照片。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十七条</b>
                                                    如甲方连续3个月未发生交易的，乙方有权重新核验甲方商户身份，如无法核实或核实后不再具备受理资质时，乙方有权单方面终止本协议；
                                                    <b>如甲方连续12个月未发生交易的，乙方有权单方面终止本协议。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十八条
                                                        乙方除有权根据本协议及附件约定外，还有权根据中国人民银行、中国银联、境外卡组织、中国清算协会已发布的及后续发布的各类通知、要求、指导意见等规范性文件内容对甲方进行监督管理并采取必要措施。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第十九条
                                                    </b>甲方所有在线操作包括在乙方网站、业务系统、微信服务平台、APP等的操作和交易，甲方的登录账号和密码是乙方验证甲方身份的重要印签，甲方对此负有保密责任。
                                                    <b>凡使用甲方登录账号和密码进行的线上操作和交易均视为甲方亲自办理的有效委托，具有同书面委托同等的法律效力。
                                                        甲方对使用甲方登录账号和密码进行的所有线上操作及交易结果承担全部经济和法律责任，有证据证明系乙方原因导致甲方账号、密码泄露的情形除外。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第二十条
                                                        甲方同意并指定数据处理方（含其分支机构及总公司，详见《拉卡拉商户注册登记表》）为其提供数据处理服务，同意并授权数据处理方为终端布放与受理标识张贴、终端维护、商户培训、耗材配送、交易证明材料调取、对账目的收集、
                                                        存储并向乙方传送甲方通过线下或线上方式提供的入网信息（包括但不限于《拉卡拉商户注册登记表》中的信息、商户提交的电子版及纸质版资料以及监管部门要求的其他信息），同意并授权乙方将甲方金融信息（包括甲方企业名称、统一社会信用代码、法定代表人姓名及证件号码、经营地址、联系人姓名及证件号码、联系人手机号、联系人电子邮箱、结算账户信息、交易数据、入账信息、对账单明细数据，下同）提供给数据处理方，同意并授权数据处理方从乙方接收并处理前述甲方相关信息。
                                                        乙方已要求数据处理方按照国家法律法规规定对该等信息采取安全保护措施。若甲方不同意前述授权，甲方可拨打乙方客服电话95016，取消授权。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第二十一条
                                                        甲方同意并授权乙方直接或通过数据处理方接收并按以下方式使用甲方信息将甲方通过线下或线上方式提供的入网信息（包括但不限于《拉卡拉商户注册登记表》中的信息、商户提交的电子版及纸质版资料以及监管部门要求的其他信息）用于乙方支付业务特约商户入网审核、反洗钱管理、实名制管理、风控评估。
                                                        同时，甲方同意并授权乙方以加密传输方式将甲方信息共享给具备提供验证服务资质的第三方机构进行一致性比对并输出核验结果，同意并授权第三方机构使用甲方的信息用于验证服务并以加密传输的方式向乙方返回核验结果。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第二十二条
                                                        鉴于甲方结算账户所属银行会不定期开展商户手续费补贴等营销活动，甲方同意乙方推荐甲方参加结算行账户所属银行的营销活动，将甲方金融信息提供给甲方结算账户所属银行（包括该银行相关分支行），用于评估甲方是否符合活动要求，对营销活动期间相关数据进行风控管理、考核对账的目的，甲方同意并授权银行从乙方接收并处理前述甲方相关信息。乙方已要求银行按照国家法律法规规定对该等信息采取安全保护措施。若甲方不同意前述授权，甲方可拨打乙方客服电话95016，取消授权。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第二十三条</b>
                                                    乙方将对甲方金融信息严格保密，除本协议约定情形外，不会泄露或者非法向他人提供甲方金融信息。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第二十四条
                                                        本协议执行过程中，如中国人民银行、中国银联、境外卡组织等相关监管机构或行业组织的相关规定或乙方业务规则、市场政策发生变化，导致支付业务规则发生变化或者本协议项下的费用发生变化，乙方可以单方面调整相关条款约定。</b>
                                                </div>
                                                <div class="ag-content-content-title-span">
                                                    <b>甲方理解并同意乙方采取在官方网站公告、电子服务渠道信息推送、邮件或短信通知等方式向甲方发起变更通知。如甲方不同意该变更后的内容，应停止使用乙方服务；
                                                        如甲方在获知或在合理时限内应当获知乙方变更通知后，仍继续使用乙方服务的，视为同意对协议涉及条款进行变更。</b>
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content-title"><b>第二十五条</b>
                                                    甲方可通过【拉卡拉商户通APP】或客服热线95016进行业务咨询、查账、投诉等操作。
                                                </div>
                                            </div>
                                            <div class="ag-content-content">
                                                <div class="ag-content-content">
                                                    <div class="ag-content-content-title"><b>第二十六条</b>
                                                        任何一方违反本协议约定，另一方有权要求在合理期限内纠正，要求赔偿因此遭受的直接经济损失。但<b>任何一方均无须向对方的间接损失、预期利益承担赔偿责任。</b>
                                                    </div>
                                                </div>
                                                <div class="ag-content-content">
                                                    <div class="ag-content-content-title"><b>第二十七条</b>
                                                        除本协议另有约定外，双方均有权根据业务需要单方解除或终止本协议，但应提前30天通知对方。
                                                    </div>
                                                </div>
                                                <div class="ag-content-content">
                                                    <div class="ag-content-content-title"><b>第二十八条</b> 通知</div>
                                                    <div class="ag-content-content-title-span">
                                                        1．甲方确认，其在《拉卡拉商户注册登记表》中指定的“联系人”、“联系地址”、“联系人电子邮箱”、“联系人电话”等联系信息可用于乙方处理本协议项下事务时向甲方履行通知、文件物品递送义务。
                                                        其中，“联系人”负责对本协议所涉事务的沟通、文件物品的签收、移交等事宜。乙方发送到甲方指定的“联系地址”、“联系人电子邮箱”即视为对甲方的有效送达。
                                                    </div>
                                                    <div class="ag-content-content-title-span">
                                                        2．甲方确认，其变更《拉卡拉商户注册登记表》中指定的联系信息时，应至少提前5个工作日以书面方式通知乙方。因甲方未及时通知导致乙方依照本协议约定联系信息履行通知、文件物品递送义务的，乙方的通知、文件物品（包括但不限于设备、文件及资料等）自发送之日起第3个工作日（含）视为乙方送达之日。
                                                    </div>
                                                </div>
                                                <div class="ag-content-content">
                                                    <div class="ag-content-content-title"><b>第二十九条</b> 争议解决
                                                        <div class="ag-content-content-title-span">
                                                            1．双方在履行本协议过程中发生的任何争议双方应首先协商解决，协商不成，任何一方可将该争议<b>提请上海国际经济贸易仲裁委员会按照该会仲裁规则进行仲裁。</b>
                                                        </div>
                                                        <div class="ag-content-content-title-span">
                                                            2．由于计算错误或其它原因导致乙方向甲方多支付的款项或其它经甲方确认的长款。
                                                        </div>
                                                        <div class="ag-content-content-title-span">
                                                            3．因甲方原因导致的发卡机构退单或卡组织追究乙方违约金。
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="ag-content-content">
                                                    <div class="ag-content-content-title"><b>第三十条</b> 协议生效</div>
                                                    <div class="ag-content-content-title-span">1. 本协议自甲方签字后生效，有效期为一年。
                                                        有效期届满后如双方无任何书面异议，本协议将自动延期，每次延期一年，依此类推。若甲乙任何一方对延期有异议，应于协议当次届满前一个月向对方书面提出异议。
                                                        甲乙双方过往签订的协议如与本协议有冲突以本协议为准。
                                                    </div>
                                                    <div class="ag-content-content-title-span">2.
                                                        本协议未尽事宜，双方可另行协商签订补充协议，本协议附件及补充协议是本协议不可分割的组成部分。
                                                    </div>
                                                    <b>
                                                        <div class="ag-content-content-title-span">3.
                                                            本协议附件包括《银行卡支付业务服务条款》、《拉卡拉扫码支付业务条款》、《境外银行卡支付业务条款》、《互联网支付服务条款》及其子附件（《代付服务基本条款》、《互联网快捷支付服务基本条款》、
                                                            《网银B2C/B2B支付服务基本条款》、《协议支付服务基本条款》、《第三方支付服务基本条款》）、《拉卡拉用户隐私政策》，上述附件由甲方登陆拉卡拉官方网站（www.lakala.com）查阅、下载并留存。
                                                            上述附件内容与本协议约定冲突的，以本协议约定为准。
                                                        </div>
                                                        <div class="ag-content-content-title-span">4.
                                                            本协议中，乙方遵照监管规范，按照最少必要原则收集、使用甲方的金融信息，用以向甲方提供服务、保障服务质量、保障甲方的账户和资金安全以及符合国家法律法规及监管规定要求，如果不同意，可能会影响服务的开通和部分服务的使用。
                                                            更多关于用户金融信息保护的内容，请查阅《拉卡拉用户隐私政策》
                                                        </div>
                                                    </b>
                                                </div>
                                                <div class="ag-content-content">
                                                    <div class="ag-content-content-title">
                                                        <b>甲方声明：乙方已采取合理方式提请甲方注意本协议、附件及官方网站公示内容的条款，并详细说明；甲方在本协议上签字视为同意本协议、附件及官方网站公示内容的条款。</b>
                                                    </div>
                                                </div>
                                                <div class="ag-content-content">
                                                    <div class="ag-content-content-title">
                                                        <div class="table">
                                                            <br />
                                                            <br />
                                                            <div class="table-title"><b>拉卡拉商户注册登记表</b></div>
                                                            <br />
                                                            <br />
                                                            <div class="table-content">
                                                                <table style="text-align: center" border="0"
                                                                    cellspacing="1" cellpadding="4">
                                                                    <tr colspan="4">
                                                                        <td colspan="4" class="tb-title">
                                                                            <b>执照信息</b>
                                                                        </td>
                                                                    </tr>

                                                                    <tr style="width: 100%">
                                                                        <td style="">
                                                                            <span class="td-con"> 营业执照号</span>
                                                                        </td>
                                                                        <td style="">
                                                                            "--"
                                                                        </td>
                                                                        <td style="">
                                                                            <span class="td-con"> 法人</span>
                                                                        </td>
                                                                        <td style="">
                                                                            '--'
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">执照名/商户名</td>
                                                                        <td style="">
                                                                            "--"
                                                                        </td>
                                                                        <td style="">身份证号</td>
                                                                        <td style="">
                                                                            "--"
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">所在区域</td>
                                                                        <td style="">
                                                                            "--"
                                                                        </td>
                                                                        <td style="">有效期</td>
                                                                        <td style="">
                                                                            "--"
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">详细地址</td>
                                                                        <td colspan="3" style="">
                                                                            "--"
                                                                        </td>
                                                                    </tr>
                                                                    <tr colspan="4">
                                                                        <td colspan="4" class="tb-title">
                                                                            <b>结算信息</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">入账户名</td>
                                                                        <td style="">
                                                                            {{ businessInformation.accountCardName ||
                                            "--" }}
                                                                        </td>
                                                                        <td style="">身份证号</td>
                                                                        <td style="">
                                                                            {{ businessInformation.idCardNumber || "--"
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">入款账号</td>
                                                                        <td style="">
                                                                            {{ businessInformation.accountCardNumber ||
                                            "--" }}
                                                                        </td>
                                                                        <td style="">有效期</td>
                                                                        <td style="">
                                                                            {{ businessInformation.idCardValidDate }}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">开户行</td>
                                                                        <td colspan="3">{{
                                            businessInformation.accountCardBankName ||
                                            "--" }}</td>
                                                                    </tr>
                                                                    <tr colspan="4">
                                                                        <td colspan="4" class="tb-title">
                                                                            <b>商户信息</b>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">签购单名称</td>
                                                                        <td style="">
                                                                            "--"
                                                                        </td>
                                                                        <td style="">对账单邮箱</td>
                                                                        <td style="">
                                                                            "--"
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">联系人</td>
                                                                        <td style="">
                                                                            {{
                                            businessInformation.accountCardName || "--"
                                        }}
                                                                        </td>
                                                                        <td style="">商户类别</td>
                                                                        <td style="">{{ "TP_PERSONAL" }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">手机号</td>
                                                                        <td style="">
                                                                            {{
                                            businessInformation.mobile ||
                                            "--"
                                        }}
                                                                        </td>
                                                                        <td style="">商户地址</td>
                                                                        <td style="">
                                                                            {{
                                                                            businessInformation.address || "--"

                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="">数据处理方</td>
                                                                        <td colspan="3">珠海易伙伴科技有限公司</td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="back">
            返回
        </div>
    </div>
</template>
<script>
export default {
    props: {
        businessInformation: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    methods: {
        back() {
            this.$emit("close")
        }
    }
};
</script>
<style scoped lang="scss">
.agreement_page {
    // padding-bottom: 30rpx;
    padding: 18px 18px 60px;
    box-sizing: border-box;
    background-color: #fff;

    .subt {
        width: 95%;
    }

    .alert-as {
        // padding: 15rpx;
    }

    .alert-ti {
        width: 100%;
        margin: 0 auto;
        margin-top: 0.5rem;
        font-size: 0.7rem;
        height: 7%;
        font-weight: 600;
        text-align: center;
    }

    .tb-title {
        text-align: center;
        font-weight: 800;
        background: rgb(177, 178, 177);
        font-size: 14px;
    }

    .ag-title {
        text-align: center;
        font-weight: 600;
        padding-top: 32px;
        padding-bottom: 16px;
    }

    body {
        font-size: 14px;
        font-family: Helvetica, Arial, "Hiragino Sans GB", "Microsoft Yahei",
            "微软雅黑", STHeiti, "华文细黑", sans-serif;
        padding: 8px;
    }

    .feeWrite {
        font-weight: 600;
        text-decoration: underline;
    }

    .feeWrite2 {
        font-weight: 600;
        font-size: 16px;
        text-decoration: underline;
    }

    b {
        font-weight: 800;
    }

    .ag-content-content {
        margin-bottom: 8px;
    }

    .ag-content-content-title {
        display: block;
        text-indent: 2em;
    }

    .ag-content-content-title-span {
        text-indent: 2em;
    }

    table {
        // background: #000;
        font-size: 11px;
        width: 100%;
        text-indent: 0;
        border-collapse: collapse;
    }

    table td {
        background: #fff;
        line-height: 20px;
        height: 20px;
    }

    table,
    th,
    td {
        border: 1px solid black;
    }

    .table-title {
        text-align: center;
    }

    .tb-con {
        padding: 20px;
        display: block;
    }

    .back {
        position: fixed;
        bottom: 0px;
        left: 0;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #fff;
        color: #000;
        font-size: 16px;
        border-radius: 25px;
        border: 1px solid #ccc;
    } 
}
</style>
